import { motion } from "framer-motion";
import { Instagram, ArrowUpRight } from "lucide-react";
import { IG_URL, M, EASE } from "../lib/site";
import { MaskLines } from "./Reveal";

const TILES = [
  [M.ceiling, "Mirror ball ceiling over a packed room"],
  [M.toast, "Champagne toast at the bar"],
  [M.table, "Friends sharing drinks at a candlelit table"],
  [M.heel, "Heel on a rose-gold mirror ball"],
  [M.girls, "Friends under disco light"],
  [M.champagne, "Champagne and mirror ball"],
];

export const InstaGrid = () => (
  <section className="relative mx-auto max-w-[1400px] px-5 py-24 sm:px-10 sm:py-32" data-testid="instagram-grid-section">
    <div className="mb-12 flex flex-col justify-between gap-6 sm:flex-row sm:items-end">
      <div>
        <p className="eyebrow mb-6">05 — On The Gram</p>
        <MaskLines lines={["@elegantemelbourne"]} className="font-display text-[1.9rem] text-[#F8F6F0] sm:text-6xl lg:text-7xl" />
      </div>
      <a href={IG_URL} target="_blank" rel="noopener noreferrer" data-testid="instagram-feed-link"
        className="btn-ghost inline-flex items-center gap-3 self-start rounded-full px-7 py-4 text-[12px] font-semibold uppercase tracking-[0.2em] sm:self-auto">
        <Instagram size={16} /> Follow us <ArrowUpRight size={14} />
      </a>
    </div>
    <div className="grid grid-cols-2 gap-3 sm:gap-4 md:grid-cols-3">
      {TILES.map(([src, alt], i) => (
        <motion.a key={i} href={IG_URL} target="_blank" rel="noopener noreferrer" data-testid={`instagram-tile-${i}`}
          initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }}
          transition={{ duration: 0.9, ease: EASE, delay: (i % 3) * 0.1 }}
          className="group relative block aspect-square overflow-hidden rounded-2xl sm:rounded-[24px]">
          <img src={src} alt={alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-110" />
          <div className="absolute inset-0 flex items-center justify-center bg-[#09080B]/0 transition-colors duration-500 group-hover:bg-[#09080B]/55">
            <Instagram size={30} className="scale-75 text-[var(--glow)] opacity-0 transition-[opacity,transform] duration-500 group-hover:scale-100 group-hover:opacity-100" />
          </div>
        </motion.a>
      ))}
    </div>
  </section>
);
